module.exports = __webpack_public_path__ + "img/portrait-004.fb21ac4a.jpg";